import appIcon from "../../assets/images/getIt_preview/1024.png";
import homeScreen from "../../assets/images/getIt_preview/home_screen.png";
import "./GetItPage.css";

function GetItPage() {
  return (
    <section className="get-it-page">
      <div className="get-it-page__hero">
        <div className="get-it-page__left">
          <h1 className="get-it-page__headline">
            Guess how your friends think
            <br />
            in a dynamic rating game
            <br />
            across different topics.
          </h1>

          <div className="get-it-page__app-icon-frame">
            <img
              src={appIcon}
              alt="Get It app icon"
              className="get-it-page__app-icon"
            />
          </div>

          <a
            href="https://apps.apple.com/us/app/get-it-the-partygame/id6756636249"
            target="_blank"
            rel="noopener noreferrer"
            className="get-it-page__download-button"
          >
            Download Now
          </a>
        </div>

        <div className="get-it-page__right">
          <img
            src={homeScreen}
            alt="Get It home screen"
            className="get-it-page__preview-image"
          />
        </div>
      </div>
    </section>
  );
}

export default GetItPage;
